module.exports = __webpack_public_path__ + "static/cypress-9e27892650f2906541ecfee29c7c8aa1.svg";